import { useState, useEffect } from 'react';
import { apiService } from '../utils/apiService';

export const useExhibitionsAndPavilions = () => {
  const [exhibitions, setExhibitions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadExhibitions = async () => {
      try {
        setLoading(true);
        setError(null);
        const fetchedExhibitions = await apiService.getExhibitions();
        setExhibitions(fetchedExhibitions);
      } catch (err) {
        console.error('Error in useExhibitionsAndPavilions:', err);
        setError(err.message || 'Failed to fetch exhibitions');
      } finally {
        setLoading(false);
      }
    };

    loadExhibitions();
  }, []);

  return { exhibitions, loading, error };
};